<div class="compliance-wrapper">
  <!-- Breadcrumb -->
  <div class="breadcrumb-nav">
    <a [routerLink]="['/Dashboard']">Dashboard</a>
    <span class="separator">&gt;</span>
    <span class="current">Compliance Pages</span>
  </div>

  <!-- Page Title -->
  <h1 class="page-title">Compliance Pages</h1>

  <!-- Top Info Banner -->
  <div class="info-banner">
    <div class="info-icon">
      <i class="fas fa-info-circle"></i>
    </div>
    <div class="info-text">
      <div class="main-msg">Upload and manage your organization's compliance policy documents.</div>
      <div class="sub-msg">Only .docx files are allowed. Maximum file size: 25MB</div>
    </div>
  </div>

  <!-- 3 Policy Cards Grid -->
  <div class="row policy-cards-row">
    <div class="col-lg-4 col-md-12 mb-4" *ngFor="let key of cardKeys">
      <div class="card policy-card">
        
        <!-- Card Header -->
        <div class="card-top-section">
          <div class="icon-circle">
            <i [class]="cards[key].iconClass"></i>
          </div>
          <div class="title-block">
            <h3 class="card-title">{{ cards[key].title }}</h3>
            <p class="card-subtitle">{{ cards[key].description }}</p>
          </div>
        </div>

        <!-- Upload New Revision Section -->
        <div class="upload-section">
          <div class="section-label">Upload New Revision</div>

          <!-- Dropzone -->
          <div 
            class="dropzone-box" 
            [class.has-file]="cards[key].selectedFile"
            (dragover)="onDragOver($event)"
            (drop)="onDrop($event, key)"
          >
            <input 
              type="file" 
              [id]="'fileInput_' + key" 
              accept=".docx" 
              class="d-none" 
              (change)="onFileSelected($event, key)" 
            />

            <!-- Empty Dropzone View -->
            <div *ngIf="!cards[key].selectedFile" class="dropzone-content">
              <div class="cloud-icon">
                <i class="fas fa-cloud-upload-alt"></i>
              </div>
              <div class="drag-text">Drag & drop your .docx file here</div>
              <div class="or-text">or</div>
              <label [for]="'fileInput_' + key" class="choose-file-btn mb-0">
                Choose File
              </label>
            </div>

            <!-- Selected File View -->
            <div *ngIf="cards[key].selectedFile" class="selected-file-content">
              <div class="file-info">
                <i class="fas fa-file-word file-word-icon"></i>
                <div class="file-meta">
                  <div class="file-name">{{ cards[key].selectedFile?.name }}</div>
                  <div class="file-size">{{ ((cards[key].selectedFile?.size || 0) / 1024).toFixed(1) }} KB</div>
                </div>
              </div>
              <button type="button" class="btn-clear-file" (click)="removeFile(key)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>


          <!-- Upload Button -->
          <button 
            type="button" 
            class="btn-upload" 
            [disabled]="!cards[key].selectedFile || cards[key].uploading"
            (click)="uploadPolicy(key)"
          >
            <span *ngIf="cards[key].uploading">
              <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
              Uploading...
            </span>
            <span *ngIf="!cards[key].uploading">
              <i class="fas fa-upload mr-1"></i> Upload
            </span>
          </button>
        </div>

        <!-- Divider Line -->
        <hr class="card-divider" />

        <!-- Revision History Section -->
        <div class="history-section">
          <div class="history-header">
            <span class="section-label">Revision History</span>
          </div>

          <!-- Loading state for history -->
          <div *ngIf="cards[key].loading" class="history-loading">
            <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
          </div>

          <!-- Fallback if no history yet -->
          <div *ngIf="!cards[key].loading && (!cards[key].history || cards[key].history.length === 0)" class="empty-history">
            <div class="revision-row">
              <div class="rev-badge">v{{ cards[key].currentVersion || '1' }}</div>
              <div class="rev-details">
                <div class="doc-title-line">
                  <span class="doc-name">{{ formatDocName(cards[key].title, cards[key].currentVersion || '1') }}</span>
                  <span class="status-badge published">Published</span>
                </div>
                <div class="rev-meta">By System Super Admin • Active Version</div>
              </div>
              <button type="button" class="btn-eye" title="Preview Published Content" (click)="openPreview(key)">
                <i class="far fa-eye"></i>
              </button>
            </div>
          </div>

          <!-- History items list -->
          <div *ngIf="!cards[key].loading && cards[key].history && cards[key].history.length > 0" class="history-list">
            <div 
              class="revision-row" 
              *ngFor="let rev of (cards[key].showAllRevisions ? cards[key].history : cards[key].history.slice(0, 2))"
            >
              <div class="rev-badge">v{{ rev.version }}</div>
              <div class="rev-details">
                <div class="doc-title-line">
                  <span class="doc-name">{{ formatDocName(cards[key].title, rev.version) }}</span>
                  <span class="status-badge published">Published</span>
                </div>
                <div class="rev-meta">
                  By {{ rev.updatedBy || 'System Super Admin' }} • {{ rev.updatedAt }}<span *ngIf="rev.time">, {{ rev.time }}</span>
                </div>
              </div>
              <button type="button" class="btn-eye" title="Preview Content" (click)="openPreview(key)">
                <i class="far fa-eye"></i>
              </button>
            </div>
          </div>

          <!-- View All Revisions Link -->
          <div 
            class="view-all-link" 
            *ngIf="cards[key].history && cards[key].history.length > 2"
            (click)="toggleViewAllRevisions(key)"
          >
            {{ cards[key].showAllRevisions ? 'Show Less Revisions' : 'View All Revisions' }}
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Bottom Info Banner -->
  <div class="info-banner bottom-banner mt-2">
    <div class="info-icon">
      <i class="fas fa-info-circle"></i>
    </div>
    <div class="info-text">
      <div class="main-msg">These compliance documents will be available to your users on the public site.</div>
    </div>
  </div>
</div>

<!-- Preview Modal -->
<div *ngIf="previewModalOpen" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-weight-bold">
          <i class="far fa-file-alt text-success mr-2"></i>{{ previewTitle }} - Published Preview
        </h5>
        <button type="button" class="close" (click)="closePreview()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body p-4" [innerHTML]="previewContent">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closePreview()">Close</button>
      </div>
    </div>
  </div>
</div>
